export default __webpack_public_path__ + "static/media/blue1.833cb961.jpg";